<a href="{{ getCurrentPage() }}#main" id="skipToContent" class="skip-link">Skip to main content</a>
<div class="wrapper">
  <ui-header
    [currentUser]="currentUser!"
    [homeApp]="homeApp"
    [isHomeApp]="false"
    [includeMainMenu]="false"
    [includeAccountBtns]="true"
    [strapline]="false"
    [logoutAction]="logoutAction"
  ></ui-header>


  <nav class="breadcrumb-bar pt-12" aria-label="breadcrumb">
    <div class="container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="{{ homeAppUri }}">Home</a></li>
        @for (breadcrumb of breadcrumbs; track breadcrumb.name) {
          <li class="breadcrumb-item">
            @if (breadcrumb.active) {
              <span [class.active]="breadcrumb.active">{{ breadcrumb.name }}</span>
            } @else {
              <a href="{{ breadcrumb.url }}">{{ breadcrumb.name }}</a>
            }
          </li>
        }
      </ol>
    </div>
  </nav>

  <main id="main" class="container clear-top">
    <a id="main-focusable" tabindex="-1">
      <!-- IE11 workaround to handle skip links -->
    </a>
    <router-outlet></router-outlet>
  </main>

  <ui-footer lite="lite"></ui-footer>
</div>
